// The scripted conversation played by the in-sidebar DemoPlayer. Mirrors
// ResolutionEngine/scripts/mock-session.ts so the demo experience inside
// Zoom matches what the terminal mock produces. When we get real RTMS audio
// this module is unused.

export interface DemoSegment {
  /** "mediator" | "alex" | "jordan" — mapped to speaker_0/1/2 below. */
  speaker: 'mediator' | 'alex' | 'jordan';
  text: string;
  /** Seconds to wait BEFORE sending this segment (relative to the previous). */
  waitAfterPrev: number;
  /** Utterance duration in seconds. Drives the transcript timestamps. */
  duration: number;
}

export const DEMO_SEGMENTS: DemoSegment[] = [
  {
    speaker: 'mediator',
    text: "Hi Alex, hi Jordan, thanks for both taking the call. I'm here to help find something that works for everyone.",
    waitAfterPrev: 0,
    duration: 5,
  },
  {
    speaker: 'alex',
    text: "Yeah, I appreciate it. I want to pay, I just can't do the full three-month plan you sent last time.",
    waitAfterPrev: 1,
    duration: 5,
  },
  {
    speaker: 'mediator',
    text: 'I hear you. Can you tell me what happened with your employment?',
    waitAfterPrev: 1,
    duration: 3,
  },
  {
    speaker: 'alex',
    text: "I got laid off at the end of January. I've been doing gig work since but it's not covering the full rent plus the back balance.",
    waitAfterPrev: 1,
    duration: 7,
  },
  {
    speaker: 'jordan',
    text: "We'd like to work with Alex on this. The main concern from our side is the lease renewal coming up in May.",
    waitAfterPrev: 2,
    duration: 6,
  },
  {
    speaker: 'alex',
    text: "Yeah, I definitely want to stay. I've been there almost a year, never had any issues until this.",
    waitAfterPrev: 1,
    duration: 5,
  },
  {
    speaker: 'mediator',
    text: 'OK. What if we stretched the repayment over more months to lower the monthly hit?',
    waitAfterPrev: 2,
    duration: 4,
  },
  {
    speaker: 'jordan',
    text: 'We can go up to six months on the plan. Anything longer we have to escalate.',
    waitAfterPrev: 1,
    duration: 4,
  },
  {
    speaker: 'alex',
    text: "If it's six months, I can do about $1,600 a month on top of my regular rent. That's about what I can stretch to.",
    waitAfterPrev: 2,
    duration: 6,
  },
  {
    speaker: 'mediator',
    text: 'Let me check the math. Total owed is $3,700. Six months at $1,600 would be $9,600, which is way more than the arrears.',
    waitAfterPrev: 2,
    duration: 7,
  },
  {
    speaker: 'alex',
    text: 'Oh, I thought that was including my normal rent. If it just covers the old balance, I could do like $620 a month.',
    waitAfterPrev: 1,
    duration: 6,
  },
  {
    speaker: 'mediator',
    text: "Right — $620 times six is $3,720, basically covers it. Plus regular rent of $1,850 on top. That's $2,470 a month.",
    waitAfterPrev: 2,
    duration: 8,
  },
  {
    speaker: 'alex',
    text: "Yeah, I can commit to $2,470 a month for six months. Starting May 1st.",
    waitAfterPrev: 2,
    duration: 4,
  },
  {
    speaker: 'jordan',
    text: "Works for us. And we'll waive the $150 in late fees that accrued, as long as payments stay on time.",
    waitAfterPrev: 1,
    duration: 5,
  },
  {
    speaker: 'mediator',
    text: 'Great. So to confirm — $2,470 monthly for six months starting May 1, late fees waived, and lease renewal on completion?',
    waitAfterPrev: 2,
    duration: 7,
  },
  {
    speaker: 'alex',
    text: 'Yes, agreed.',
    waitAfterPrev: 1,
    duration: 1,
  },
  {
    speaker: 'jordan',
    text: "Agreed on our side too. We'll offer a 12-month renewal if the plan completes clean.",
    waitAfterPrev: 1,
    duration: 5,
  },
];

export const SPEAKER_LABEL: Record<DemoSegment['speaker'], string> = {
  mediator: 'speaker_0',
  alex: 'speaker_1',
  jordan: 'speaker_2',
};
